import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from './LoadingSpinner.styles';
/**
 * Loading Spinner animated component - NOT themeable
 *
 * ```js
 *
 * import LoadingSpinner from '@minerva-analytics/pantheon';
 * <LoadingSpinner />
 * ```
 * with a custom color:
 *
 * ```js
 * import LoadingSpinner from '@minerva-analytics/pantheon';
 * <LoadingSpinner color={`#FF0000`} />
 * ```
 * **Default Styles**
 *
 * To view the component's styling directly, see [LoadingSpinner.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/elements/LoadingSpinner/LoadingSpinner.styles.js)
 *
 */

export var LoadingSpinner = function LoadingSpinner(props) {
  return /*#__PURE__*/React.createElement(Loader, {
    color: props.color
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null));
};
LoadingSpinner.propTypes = {
  /* A custom color to pass to the loading spinner */
  color: PropTypes.string
};
export default LoadingSpinner;